export default __webpack_public_path__ + "static/media/house-7.6dd0469e.jpg";